"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paypalOnload = void 0;
const paypal_1 = require("./");
const actions_1 = require("../actions");
const variables_1 = require("../variables");
function paypalOnload(payment) {
    return __awaiter(this, void 0, void 0, function* () {
        const paypal = (0, paypal_1.getPaypalNameSpace)();
        const paypalDivId = 'paypal-express-payment';
        if (paypal === null || paypal === void 0 ? void 0 : paypal.Buttons) {
            const button = paypal.Buttons({
                createOrder: paypal_1.paypalCreateOrder,
                onClick: paypal_1.paypalOnClick,
                onShippingChange: paypal_1.paypalOnShippingChange,
                onApprove: paypal_1.paypalOnApprove,
                style: Object.assign(Object.assign({}, payment.button_style), { height: 39 })
            });
            // creating a paypal payment div inside express payment container
            const paypalDiv = document.createElement('div');
            paypalDiv.id = paypalDivId;
            paypalDiv.className = `${paypalDivId} express-payment`;
            const container = document.getElementById('express-payment-container');
            container === null || container === void 0 ? void 0 : container.appendChild(paypalDiv);
            if (container && button.isEligible()) {
                yield button.render(`#${paypalDivId}`);
                (0, actions_1.enableDisableSection)(variables_1.showPaymentMethodTypes.PAYPAL, true);
            }
            else {
                paypalDiv.style.display = 'none';
            }
        }
    });
}
exports.paypalOnload = paypalOnload;
